// extracted by mini-css-extract-plugin
export default {"modalFooter":"ManageCustomFormatsEditModalContent-modalFooter-zjkFe ModalFooter-modalFooter-wjkx5","selected":"ManageCustomFormatsEditModalContent-selected-boz8Z"};